import { useCombinedListParamsContext } from "@bundles/parts/components/ListV2/ContextProvider/ListParams"
import { PurePartsListParams } from "@bundles/parts/components/ListV2/models"

export function usePureListParamsContext<TContext extends PurePartsListParams>(): TContext
export function usePureListParamsContext<TContext extends PurePartsListParams, TReturnType>(selector: (value: TContext) => TReturnType): TReturnType
export function usePureListParamsContext<TContext extends PurePartsListParams, TReturnType>(
    selector?: (value: TContext) => TReturnType
): TReturnType | TContext {
    return useCombinedListParamsContext(selector as never)
}
